<!--
 * @Author: wsx
 * @Date: 2022-02-23 17:00:48
 * @LastEditTime: 2022-02-11 17:52:34
 * @LastEditors: Please set LastEditors
 * @Description: 文件上传
 * @FilePath: \smart-community\src\components\global\HUpload.vue
-->
<template>
  <div class="HUpload" ref="uploadStyle">
    <el-upload
      action="#"
      ref="uploadRef"
      drag
      list-type="picture-card"
      :file-list="fileList"
      :limit="isCode"
      :auto-upload="false"
      :on-change="handleBeforeUpload"
      :class="{ hide: hideUpload }"
    >
      <template #default>
        <i :style="iconStyle" class="iconfont icon-tianjia1"></i>
      </template>
      <template #file="{ file }">
        <div class="content">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
          <span class="el-upload-list__item-actions">
            <span
              class="el-upload-list__item-preview"
              @click="handlePictureCardPreview(file)"
            >
              <!-- <el-icon><zoom-in /></el-icon> -->
              <i class="iconfont icon-fangda"></i>
            </span>
            <!-- <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleDownload(file)"
            >
              <el-icon><download /></el-icon>
              <i class="iconfont icon-xiazai"></i>
            </span> -->
            <span
              v-if="!disabled"
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
            >
              <!-- <el-icon><delete /></el-icon> -->
              <i class="iconfont icon-shanchu"></i>
            </span>
          </span>
        </div>
      </template>
    </el-upload>
    <el-dialog v-model="dialogVisible" class="dialog">
      <img style="width: 100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
  onMounted,
} from "vue";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "HUpload",
  components: {},
  props: {
    // 上传框中icon大小
    iconStyle: {
      type: Object,
      default: () => {
        return {
          fontSize: "20px",
        };
      },
    },
    // 上传一张照片后是否隐藏上传图标
    showUpload: {
      type: Boolean,
      default: false,
    },
    isCode: {
      type: String,
      default: "1",
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const state = reactive({
      fileList: [],
      disabled: false,
      hideUpload: false,
      dialogImageUrl: "",
      dialogVisible: false,
      base64File: [],
      width: "200px",
      height: "200px",
    });

    const refData = toRefs(state);
    const uploadRef = ref();
    // 组件发生改变，隐藏添加
    const handleChange = (file) => {};
    const handleBeforeUpload = (file) => {
      if (file.size > 2 * 1024 * 1024) {
        ElMessage.warning("上传文件小于2M");
        handleRemove(file);
        return;
      }
      const fileName = file.name;
      const pos = fileName.lastIndexOf(".");
      const lastName = fileName.substring(pos, fileName.length);
      if (
        lastName.toLowerCase() !== ".jpg" &&
        lastName.toLowerCase() !== ".png" &&
        lastName.toLowerCase() !== ".jepg"
      ) {
        handleRemove(file);
        ElMessage.warning("请上传.jpg  .png  .jepg文件");
        return;
      }
      if (props.showUpload) {
        state.hideUpload = true;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = (e) => {
        const code = e.target.result;
        if (props.isCode !== "") {
          if (state.base64File.length < Number(props.isCode)) {
            state.base64File.push(code);
          }
        } else {
          state.base64File.push(code);
        }
        emit("upLoadChange", state.base64File);
      };
    };
    const uploadFilesValue = (val) => {
      if (props.showUpload) {
        state.hideUpload = true;
      } else {
        state.hideUpload = false;
      }
      state.fileList.push({
        url: val,
      });
    };

    const uploadBase64FilesValue = (val) => {
      state.base64File.push(val);
      emit("upLoadChange", state.base64File);
    };
    //移除照片
    const handleRemove = (file, rawFile) => {
      const fileArray = uploadRef.value.uploadFiles;
      const index = fileArray.indexOf(file);
      fileArray.splice(index, 1);
      state.hideUpload = false;
      state.base64File = [];
      console.log(fileArray);
      if (fileArray.length) {
        fileArray.forEach((element) => {
          const reader = new FileReader();
          reader.readAsDataURL(element.raw);
          reader.onload = (e) => {
            const code = e.target.result;
            state.base64File.push(code);
            emit("upLoadChange", state.base64File);
          };
        });
      } else {
        emit("upLoadChange", state.base64File);
      }
    };
    const handlePictureCardPreview = (file) => {
      state.dialogImageUrl = file.url;
      state.dialogVisible = true;
    };
    return {
      ...refData,
      uploadRef,
      uploadFilesValue,
      handleRemove,
      handlePictureCardPreview,
      handleChange,
      handleBeforeUpload,
      uploadBase64FilesValue,
    };
  },
});
</script>
<style lang="scss" scoped>
.HUpload {
  width: 100%;
  height: 100%;
  /deep/ .el-upload-list__item {
    width: 91px !important;
    height: 91px !important;
  }
  /deep/.hide > .el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-dragger {
    width: unset;
    height: unset;
  }
  .content {
    height: 100%;
    .el-upload-list__item-thumbnail {
      height: 91px;
      width: 91px;
      object-fit: cover;
    }
  }
  /deep/.el-upload--picture-card {
    width: var(--width);
    height: var(--height);
  }
  img {
    width: 91px !important;
    height: 91px !important;
  }
}
.dialog {
  width: 100%;
  height: 100%;
  .images {
    width: 100%;
    height: 100%;
  }
}

// .h-select-list-item {
//   font-size: var(--el-font-size-base);
//   padding: 0 32px 0 5px;
//   position: relative;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   color: var(--el-text-color-regular);
//   height: 34px;
//   line-height: 34px;
//   box-sizing: border-box;
//   cursor: pointer;
//   &:hover {
//     background-color: var(--el-bg-color);
//   }
//   &.selected {
//     color: var(--el-color-primary);
//     font-weight: 700;
//   }
// }
</style>
